import { gql } from '@apollo/client';

export const ALL_ACADEMIC_LEVELS = gql`
  query academicLevels($state: [Int], $order: [[String]]) {
    academicLevels(state: $state, order: $order) {
      alId
      alName
      alState
    }
  }
`;

export const ALL_ACCOUNT_TYPES = gql`
  query accountTypes($state: [Int], $order: [[String]]) {
    accountTypes(state: $state, order: $order) {
      atId
      atName
      atCode
      atState
    }
  }
`;

export const ALL_TYPE_BATCH = gql`
  query TypeBatch($state: [Int], $order: [[String]]) {
    typeBatch(state: $state, order: $order) {
      tbId
      cId
      tbCanRepeat
      tbName
      tbCode
      tbState
    }
  }
`;

export const ALL_BENEFICIARIES = gql`
  query beneficiaries($state: [Int], $order: [[String]]) {
    beneficiaries(state: $state, order: $order) {
      bId
      bIdeNum
      bBusiness
      bFirNam
      bSecNam
      bFirLas
      bSecLas
    }
  }
`;

export const ALL_CITIES = gql`
  query cities($state: [Int], $order: [[String]]) {
    cities(state: $state, order: $order) {
      cId
      cName
      cCode
      cState
      dId
    }
  }
`;

export const ALL_COUNTRIES = gql`
  query GetAllCountries($state: [Int], $order: [[String]]) {
    getAllCountries(state: $state, order: $order) {
      countriesId
      code
      name
      nationality
      state
    }
  }
`;

export const NEW_ALL_CITIES = gql`
  query cities($state: [Int], $order: [[String]]) {
    cities(state: $state, order: $order) {
      cId
      dId
      department {
        dName
      }
      cName
      cCode
      cState
    }
  }
`;

export const ALL_COMPANIES = gql`
  query companies($state: [Int], $order: [[String]]) {
    companies(state: $state, order: $order) {
      cId
      cBusNam
      cNit
    }
  }
`;

export const ALL_CO_DEBTORS = gql`
  query coDebtors($state: [Int], $order: [[String]]) {
    coDebtors(state: $state, order: $order) {
      cdId
      cdName
    }
  }
`;

export const ALL_CREDIT_TYPES = gql`
  query creditTypes($ctGroup: Int, $state: [Int], $order: [[String]]) {
    creditTypes(ctGroup: $ctGroup, state: $state, order: $order) {
      ctId
      ctConsecutive
      ctOrder
      ctName
      ctState
    }
  }
`;

export const ALL_DEPARTMENTS = gql`
  query departments($state: [Int], $order: [[String]]) {
    departments(state: $state, order: $order) {
      dId
      dName
      dState
    }
  }
`;

export const NEW_ALL_DEPARTMENTS = gql`
  query departments($state: [Int], $order: [[String]]) {
    departments(state: $state, order: $order) {
      dId
      dName
      dCode
      dState
    }
  }
`;

export const ALL_DEPARTMENTS_WITH_CITIES = gql`
  query Departments {
    departments {
      dId
      dCode
      dName
      dState
      cities {
        cId
        dId
        cName
        cCode
        cState
        department {
          dCode
          dId
          dName
        }
      }
    }
  }
`;

export const ALL_DEPENDENTS = gql`
  query dependents($state: [Int], $order: [[String]]) {
    dependents(state: $state, order: $order) {
      dId
      dName
      dState
    }
  }
`;

export const ALL_DOCUMENT_CONTRACTS = gql`
  query documentContracts($state: [Int], $order: [[String]]) {
    documentContracts(state: $state, order: $order) {
      dcId
      dcName
      dcDocument
      dcState
    }
  }
`;

export const ALL_GENDERS = gql`
  query genders($state: [Int], $order: [[String]]) {
    genders(state: $state, order: $order) {
      gId
      gName
      gState
    }
  }
`;

export const ALL_CLIENT_CATEGORIES = gql`
  query clientCategories($state: [Int], $order: [[String]]) {
    clientCategories(state: $state, order: $order) {
      clcId
      clcName
      clcColor
      clcInsolvency
      clcUploadDocument
      clcState
    }
  }
`;

export const ALL_METHODS = gql`
  query methods($state: [Int], $order: [[String]]) {
    methods(state: $state, order: $order) {
      mtId
      mtName
      mtState
    }
  }
`;

export const ALL_DTF_RATES = gql`
  query DtfRates($state: [Int], $order: [[String]]) {
    dtfRates(state: $state, order: $order) {
      dtfId
      dtfEndDate
      dtfStartDate
      dtfRate
      dtfState
    }
  }
`;

export const ALL_CONTACT_BY = gql`
  query ContactBy($state: [Int], $order: [[String]]) {
    contactBy(state: $state, order: $order) {
      cbId
      cbName
      cbState
    }
  }
`;

export const PREGNANCY_TIMES = gql`
  query PregnancyTimes($state: [Int], $order: [[String]]) {
    pregnancyTimes(state: $state, order: $order) {
      ptId
      ptName
      ptState
    }
  }
`;

export const ALL_TYPE_IDENTITIES = gql`
  query typeIdentities($state: [Int], $order: [[String]]) {
    typeIdentities(state: $state, order: $order) {
      tiId
      tiName
      tiState
      tiPrefix
      tiCode
    }
  }
`;
export const ALL_TYPE_NOTIFICATIONS = gql`
  query TypeNotifications {
    typeNotifications {
      tnId
      tnName
      tnLibranza
      tnCompany
      tnPayroll
      tnInvestor
      tnUser
      tnSeller
      tnBeneficiary
      nId
      notification {
        nCode
      }
    }
  }
`;

export const ALL_INVESTORS = gql`
  query investors($state: [Int], $order: [[String]]) {
    investors(state: $state, order: $order) {
      iId
      iIdeNum
      iFirNam
      iSecNam
      iFirLas
      iSecLas
    }
  }
`;

export const ALL_MARITAL_STATUS = gql`
  query maritalStatus($state: [Int], $order: [[String]]) {
    maritalStatus(state: $state, order: $order) {
      msId
      msName
      msState
    }
  }
`;

export const ALL_MONTHS = gql`
  query months($state: [Int], $order: [[String]]) {
    months(state: $state, order: $order) {
      mId
      mValue
    }
  }
`;

export const ALL_NOTIFICATIONS = gql`
  query notifications($state: [Int], $order: [[String]]) {
    notifications(state: $state, order: $order) {
      nId
      nCode
      nName
      nTitle
      nMessage
      nState
    }
  }
`;

export const ALL_PHASES = gql`
  query phases($order: [[String]]) {
    phases(order: $order) {
      pId
      csId
      paId
      phaseAction {
        paName
      }
      creditState {
        csId
        csName
      }
      pName
      pConsecutive
      pOrder
      pState
    }
  }
`;

export const ALL_INSURANCE_ENTITIES = gql`
  query GetAllInsuranceEntities($order: [[String]], $state: [Int]) {
    getAllInsuranceEntities(order: $order, state: $state) {
      ieId
      ieName
      ieState
    }
  }
`;

export const DELETE_PHASE_BY_ID = gql`
  mutation DeletePhase($pId: ID) {
    deletePhase(pId: $pId) {
      pId
      pState
    }
  }
`;

export const ALL_PHASE_ACTIONS = gql`
  query phaseActions($order: [[String]]) {
    phaseActions(order: $order) {
      paId
      paName
      paState
    }
  }
`;

export const ALL_PLANS = gql`
  query plans($state: [Int], $order: [[String]]) {
    plans(state: $state, order: $order) {
      pId
      pName
      pMinimum
      pPriority
      pPor
      pState
    }
  }
`;

export const ALL_RATES = gql`
  query rates($state: [Int], $order: [[String]]) {
    rates(state: $state, order: $order) {
      rId
      rNam
      rPor
    }
  }
`;

export const ALL_RELATIONSHIPS = gql`
  query relationships($state: [Int], $order: [[String]]) {
    relationships(state: $state, order: $order) {
      rId
      rName
      rState
    }
  }
`;

export const ALL_SALARIES = gql`
  query salaries($state: [Int], $order: [[String]]) {
    salaries(state: $state, order: $order) {
      sId
      sName
      sValue
    }
  }
`;

export const ALL_SELLERS = gql`
  query sellers($state: [Int], $order: [[String]]) {
    sellers(state: $state, order: $order) {
      sId
      tiId
      typeIdentity {
        tiPrefix
      }
      sIdeNum
      sBusiness
      sFirNam
      sSecNam
      sFirLas
      sSecLas
      srId
      sSellerCode
    }
  }
`;

export const ALL_TYPE_ADDRESS = gql`
  query typeAddress($state: [Int], $order: [[String]]) {
    typeAddress(state: $state, order: $order) {
      taId
      taName
      taState
    }
  }
`;

export const ALL_TYPE_ATTRIBUTES = gql`
  query typeAttributes($state: [Int], $order: [[String]]) {
    typeAttributes(state: $state, order: $order) {
      taId
      taConsecutive
      taName
      taPor
      rId
      typeAttributeDocuments {
        tadId
        bId
        dcId
        tadState
      }
    }
  }
`;

export const ALL_TYPE_BANKS = gql`
  query typeBanks($state: [Int], $order: [[String]]) {
    typeBanks(state: $state, order: $order) {
      tbId
      tbCode
      tbName
    }
  }
`;

export const ALL_TYPE_MUT_BANKS = gql`
  query mutualBanks($state: [Int], $order: [[String]]) {
    mutualBanks(state: $state, order: $order) {
      mbId
      mbAccNum
      mbAccCont
      tbId
      atId
      accountType {
        atName
      }
      typeBank {
        tbName
      }
    }
  }
`;

export const ALL_TYPE_BONDS = gql`
  query typeBonds($state: [Int], $order: [[String]]) {
    typeBonds(state: $state, order: $order) {
      tbId
      tbName
    }
  }
`;

export const ALL_TYPE_BONDS_LIST = gql`
  query typeBonds($state: [Int], $order: [[String]]) {
    typeBonds(state: $state, order: $order) {
      tbId
      tbName
      tbState
      bonds {
        bId
        bCategory
        bPor
        bState
      }
    }
  }
`;

export const ALL_TYPE_CONTRACTS = gql`
  query typeContracts($state: [Int], $order: [[String]]) {
    typeContracts(state: $state, order: $order) {
      tcId
      tcName
      tcState
    }
  }
`;

export const ALL_TYPE_FORMAT_CREDITS = gql`
  query typeFormatCredits($state: [Int]) {
    typeFormatCredits(state: $state) {
      tfcId
      tfcName
      tfcState
    }
  }
`;

export const ALL_TYPE_FORMAT_CREDITS_LIST = gql`
  query typeFormatCredits($state: [Int]) {
    typeFormatCredits(state: $state) {
      tfcId
      tfcName
      tfcState
      tfcId
      tfcValCreBef
      tfcRatBef
      tfcAttBef
      tfcRepPlaBef
      tfcRatAft
      tfcValCreAft
      tfcValCouAft
      tfcFirFeeAft
      tfcMonAft
      tfcReqValAft
      tfcValAdjAft
      tfcMetAft
      tfcCarAft
      tfcRatRisAft
      tfcBalAft
      tfcAttCreAft
      tfcPlaAmoAft
      tfcDocConAft
      tfcExcAft
      tfcState
    }
  }
`;

export const ALL_TYPE_HOUSINGS = gql`
  query typeHousings($state: [Int], $order: [[String]]) {
    typeHousings(state: $state, order: $order) {
      thId
      thName
      thState
    }
  }
`;

export const ALL_TYPE_OF_CALLS = gql`
  query typeOfCalls($state: [Int], $order: [[String]]) {
    typeOfCalls(state: $state, order: $order) {
      tcId
      tcName
      tcState
    }
  }
`;

export const ALL_COST_CENTERS = gql`
  query CostCenters($state: [Int], $order: [[String]]) {
    costCenters(state: $state, order: $order) {
      ccId
      ccName
      ccCode
      ccDescription
      ccState
    }
  }
`;

export const ALL_ATTENTION_POINTS = gql`
  query AttentionPoints($state: [Int], $order: [[String]]) {
    attentionPoints(state: $state, order: $order) {
      apId
      apCode
      apName
      apDescription
      apState
    }
  }
`;

export const ALL_SELLER_ROLS = gql`
  query SellerRol($state: [Int], $limit: [Int], $order: [[String]]) {
    sellerRol(state: $state, limit: $limit, order: $order) {
      srId
      srName
      srKey
      srState
    }
  }
`;

export const ALL_ADDITIONAL_ALLOWANCE_POSITIONS = gql`
  query additionalAllowancePositions($state: [Int], $order: [[String]]) {
    additionalAllowancePositions(state: $state, order: $order) {
      id
      name
      percentage
      state
    }
  }
`;

export const ALL_TYPE_LIFE_MILLIONS = gql`
  query typeLifeMillions($state: [Int], $order: [[String]]) {
    typeLifeMillions(state: $state, order: $order) {
      tlmId
      tlmName
    }
  }
`;

export const ALL_TYPE_LIFE_MILLIONS_LIST = gql`
  query typeLifeMillions($state: [Int], $order: [[String]]) {
    typeLifeMillions(state: $state, order: $order) {
      tlmId
      tlmFormula
      tlmName
      tlmState
      lifeMillions {
        lmId
        lmSince
        lmUntil
        lmValue
        lmValueTwo
        lmPor
        lmState
      }
    }
  }
`;

export const ALL_USER_FORMATS = gql`
  query userFormats($state: [Int], $order: [[String]]) {
    userFormats(state: $state, order: $order) {
      ufId
      ufName
    }
  }
`;
export const ALL_USER_FORMATS_LIST = gql`
  query userFormats($state: [Int]) {
    userFormats(state: $state) {
      ufId
      ufName
      ufTipIde
      ufIdeNum
      ufDatExpDoc
      ufDomExpDoc
      ufFirNam
      ufSecNam
      ufFirLas
      ufSecLas
      ufDatBir
      ufPhoMob
      ufPhoPer
      ufEmail
      ufGender
      ufLocation
      cIdStu
      ufFacultyStu
      ufNumStu
      ufNumDirStu
      ufContactBy
      ufTaxReturn
      ufTaxReturnStaff
      ufNumHouStu
      ufInfStu
      gIdStu
      taIdStu
      ufIdeNumStu
      ufEmailStu
      ufPhoStu
      ufLasStu
      ufAcaLev
      ufMarSta
      ufNamStu
      ufTypHou
      ufRentValue
      ufDependents
      ufPosition
      tiIdStu
      ufOthInc
      ufFinExp
      ufPerExp
      ufRefFam
      ufRefPar
      ufRelationship
      ufPerDoc
      ufBankStatement
      ufFinancialStatements
      ufIncomeTaxReturn
      ufBoardDirectors
      ufTradeBalance
      ufRealEstateRegistration
      ufPartners
      ufVehicleOwnershipCard
      ufCommercialReference
      ufBankReference
      ufIncomeWithholdings
      ufCadastreAndValuation
      ufCommercialAppraisal
      ufLeaseCertificate
      ufLibertyAndTraditionCertificate
      ufFroDoc
      ufRefStu
      ufRefProvee
      ufReaDoc
      ufSerDoc
      ufBanDoc
      ufConDoc
      ufOPS
      ufPayRemDoc
      ufLocBir
      ufSons
      ufMotHeaHou
      ufStratum
      ufCIIU
      ufManPubRes
      ufHolPubOff
      ufHasPubRec
      ufHasRelPubExp
      ufTypIdeSpo
      ufIdeNumSpo
      ufNamLasSpo
      ufNumPEP
      ufPEP
      ufActive
      ufPassive
      ufComActDoc
      ufBudRecDoc
      ufBudCerDoc
      ufRut
      ufComChamber
      ufInstitutionPic
      ufWeight
      ufHeight
      ufCancer
      ufVIH
      ufStroke
      ufRenIns
      ufArtHyp
      ufDiabetes
      ufCorArtDis
      ufHeaAtt
      ufHasConAcqPhyMenLim
      ufDiaTreDisOthThoMenAbo
      ufDatDia
      ufTreatment
      ufActSta
      ufIsPre
      ufPregnancy
      ufPrimitive
      ufDisabilityPensioner
      ufUseDrugsAlcohol
      ufDiseaseName
      ufConsequences
      ufObservations
      ufCurrentTreatment
      ufTreatmentOrSurgery
      ufRut
      ufComChamber
      ufInstitutionPic
      ufSarlaft
      ufLifeInsurance
      ufWorkCertificate
      ufOtherInformation
      ufEconomyActivities
      ufCirenio
      ufInsuranceEntities
      ufVehicleGarmentInformation
      ufValidationPin
      ufIncomeAndExpense
      ufRealEstate
      ufBoardDirectorsForm
      ufSpouse
      ufCompanyName
      ufAddress
      ufTypeCompany
      ufWorkPhone
      ufExt
      ufFax
      ufCorrespondence
      ufCorrespondenceInfo
      ufDepartment
      ufCity
      ufPosition
      ufTypeContract
      ufContractStart
      ufContractEnd
      ufAntiquity
      ufPreviousEmployment
      ufServiceTime
      ufPhonePreviosEmployment
      ufCityPreviousEmployment
      ufBussiness
      ufAntiquityIndependents
      ufChamberCommerce
      ufPensionFund
      ufTypePension
      ufDateResolution
      ufUniversity
      ufGenerateIncome
      ufRutEconomyActivities
      ufRetired
      # Client Knowledge
      ufNet
      ufHonorary
      ufRentIncome
      ufOtherIncome
      ufOtherIncomeConcept
      ufInterestReceived
      ufTotalIncome
      ufIncomeConcept
      ufRentExpense
      ufCardExpense
      ufVehicleFee
      ufMortgage
      ufLoans
      ufPersonalExpense
      ufFinancialExpense
      ufTotalExpense
      ufExpenseConcept
      ufLegalDiscount
      ufOtherDiscount
      ufPensionerAffiliationNumber
      # Spouse
      ufNameSpouse
      ufEmailSpouse
      ufBirthSpouse
      ufTypeIdentitySpouse
      ufIdeNumSpouse
      ufPlaceBirthSpouse
      ufGIdSpouse
      ufSpouseCompany
      ufSpousePosition
      ufAntiqueSpouse
      ufSpouseAddress
      ufPlaceResidenceSpouse
      ufPhoneSpouse
      ufIncomeSpouse
      ufCellPhoneSpouse
      ufSpouseCompanyAddress
      ufSpouseCompanyCity
      ufSpouseCompanyPhone
      # Real Estate
      ufTypeRealEstate
      ufAddressRealEstate
      ufRealEstateRegistry
      ufRealEstateRegistrationNumber
      ufMortgageRealEstate
      ufValueRealEstate
      ufPublicWritingRealEstate
      ufNotaryRealEstate
      ufCityRealEstate
      ufTypeRealEstateTwo
      ufAddressRealEstateTwo
      ufRealEstateRegistryTwo
      ufRealEstateRegistrationNumberTwo
      ufMortgageRealEstateTwo
      ufValueRealEstateTwo
      ufPublicWritingRealEstateTwo
      ufNotaryRealEstateTwo
      ufCityRealEstateTwo
      # Vehicle Garment
      ufNameVehicleGarment
      ufLastNameVehicleGarment
      ufTypeDocumentVehicleGarment
      ufIdentityNumberVehicleGarment
      ufCityVehicleGarment
      ufAddressVehicleGarment
      ufBrandVehicleGarment
      ufColorVehicleGarment
      ufTypeOfVehicleGarment
      ufModelVehicleGarment
      ufPlateVehicleGarment
      ufPercentageVehicleGarment
      ufGarmentInFavorVehicleGarment
      ufDomainReservationVehicleGarment
      ufEntityVehicleGarment
      ufMonthlyPaymentVehicleGarment
      ufEngineVehicleGarment
      ufVinVehicleGarment
      ufDisplacementVehicleGarment
      ufTypeVehicleGarment
      ufChassisVehicleGarment
      ufLineVehicleGarment
      ufSerieVehicleGarment
      ufServiceVehicleGarment
      ufManufacturerVehicleGarment
      ufCommercialValueVehicleGarment
      ufDealerNameVehicleGarment
      ufSellerNameVehicleGarment
      ufSellerIdNumberVehicleGarment
      ufThirdPartyBankAccountVehicleGarment
      # partners
      ufNameShareholdersAssociates
      ufIdeNumShareholdersAssociates
      ufAddressShareholdersAssociates
      ufPercentageShareholdersAssociates
      # other information
      ufAffiliationNumber
      ufUsNationality
      ufUsAccount
      ufUsInvestmentAssets
      ufAmericanGreenCard
      ufBornUS
      ufLivedUS
      ufForeignCurrency
      ufActivity
      ufTaxObligations
      ufBiddingActivities
      ufInfoBiddingActivities
      ufAcceptInformation
      ufBreachContract
      ufCriminallyDeclared
      ufTruthfulStatements
      ufAcceptDocument
      ufInsuredValue
      ufPremiumValue
      ufDangerHisLife
      ufInfoDangerHisLife
      ufTakesMedicine
      ufInfoTakesMedicine
      ufEPS
      ufIPS
      ufTakeDrug
      ufInfoTakeDrug
      # Junta Directiva
      ufMain
      ufMainTwo
      ufSubstitutes
      ufSubstitutesTwo
      ufNameMain
      ufAccountantRegistration
      ufTaxAuditor
      ufMachineryAndVehicles
      ufMachineryAndVehiclesTwo
      ufMachineryAndVehiclesThree
      ufMachineryAndVehiclesDescription
      ufMachineryAndVehiclesBrand
      ufMachineryAndVehiclesModel
      ufMachineryAndVehiclesCommercialValue
      ufMachineryAndVehiclesLiens
      ufMachineryAndVehiclesDescriptionTwo
      ufMachineryAndVehiclesBrandTwo
      ufMachineryAndVehiclesModelTwo
      ufMachineryAndVehiclesCommercialValueTwo
      ufMachineryAndVehiclesLiensTwo
      ufMachineryAndVehiclesDescriptionThree
      ufMachineryAndVehiclesBrandThree
      ufMachineryAndVehiclesModelThree
      ufMachineryAndVehiclesCommercialValueThree
      ufMachineryAndVehiclesLiensThree
      # Sarlaft
      ufActiveConcept
      ufPassiveConcept
      ufTotalAssets
      ufOperatingIncome
      ufCostsAndExpenses
      ufUtilities
      ufOtherIncomeAndExpense
      ufBeforeTax
      ufTaxes
      ufUtility
      ufCargoPublico
      ufRecPubl
      ufManeRecPubl
      ufRecPublEx
      ufPublicResourcesAdministration
      ufPublicFigureRecognition
      ufPublicOfficial
      ufPoliticalExposureInfluence
      ufInternationalOrganizationLegalRepresentative
      ufPublicOfficialPosition
      ufPublicOfficialStartDate
      ufPublicOfficialEndDate
      ufHasForeignCurrencyActivity
      ufTypeForeignCurrencyActivity
      ufTypeForeignCurrencyActivityOther
      ufHasForeignCurrencyProducts
      ufCurrencyOfOrigin
      ufEstimatedMonthlyAmount
      ufCountries
      ufInternationalOperations
      ufInternationalOperationsTypes
      ufForeignHeritage
      ufForeignHeritageInUS
      ufForeignHeritageOtherCountry
      ufForeignHeritageCountry
      ufHasForeignFinancialProducts
      ufForeignFinancialProductCountry
      ufForeignFinancialProductCity
      ufForeignFinancialProductType
      ufForeignFinancialProductOther
      ufForeignFinancialProductNumber
      ufForeignFinancialProductCurrency
      ufForeignFinancialProductAmount
      ufTypeIdentityRecPub
      ufIdentificationRecPub
      ufExpeditionDateRecPub
      ufExpeditionPlaceRecPub
      ufFirstNameRecPub
      ufSecondNameRecPub
      ufFirstLastNameRecPub
      ufSecondLastNameRecPub
      ufTypeFormat
      ufConstitutionDeedNumber
      ufNotary
      ufConstitutionCity
      ufConstitutionDate
      ufConstitutionExpiration
      ufLegalRepresentativeName
      ufLegalRepresentativePosition
    }
  }
`;

export const ALL_VATS = gql`
  query vats($state: [Int], $order: [[String]]) {
    vats(state: $state, order: $order) {
      vId
      vName
      vPor
      vState
    }
  }
`;

export const ALL_WAY_PAYS = gql`
  query wayPays($state: [Int], $order: [[String]]) {
    wayPays(state: $state, order: $order) {
      wpId
      wpName
      wpState
    }
  }
`;

export const ALL_FORMAT_TYPE_BANKS = gql`
  query formatTypeBanks {
    formatTypeBanks(order: [["ftbName", "ASC"]]) {
      ftbId
      ftbName
      mbId
      mutualBank {
        tbId
        typeBank {
          tbName
        }
      }
      formatAccountTypeBanksFN {
        dataValues {
          totalCount
        }
      }
      formatIdentityTypeBanksFN {
        dataValues {
          totalCount
        }
      }
      formatNumberTypeBanksFN {
        dataValues {
          totalCount
        }
      }
      ftbState
    }
  }
`;
export const ALL_CO_DEBTOR_FORMATS = gql`
  query coDebtors($state: [Int]) {
    coDebtors(state: $state) {
      cdId
      cdName
      cdTipIde
      cdIdeNum
      cdFirNam
      cdSecNam
      cdFirLas
      cdSecLas
      cdDatBir
      cdPhoMob
      cdPhoPer
      cdEmail
      cdGender
      cdLocation
      cdAcaLev
      cdMarSta
      cdTypHou
      cdDependents
      cdCompany
      cdPosition
      cdTypCon
      cdSalary
      cdOthInc
      cdFinExp
      cdPerExp
      cdPerDoc
      cdFroDoc
      cdReaDoc
      cdSerDoc
      cdBanDoc
      cdLoaDoc
      cdDateExp
      cdPlaceExp
    }
  }
`;
export const ALL_USURY_RATES = gql`
  query GetAllUsuryRates($order: [[String]], $state: [Int]) {
    getAllUsuryRates(order: $order, state: $state) {
      urId
      urMonth
      urYear
      urAdvance
      urRateArrear
      urMonthlyArrearRate
      urSemiannualArrearRate
      urFourMonthlyArrearRate
      urQuarterlyArrearRate
      urBimonthlyArrearRate
      urFortnightlyArrearRate
      urWeeklyArrearRate
      urDailyArrearRate
      urDaysArrears
      urState
    }
  }
`;

export const ALL_ACCOUNTING_DOCUMENT_TYPE = gql`
  query GetAllAccountingDocumentType {
    getAllAccountingDocumentType {
      adtId
      stId
      adtName
      adtCode
      adtType
      adtState
      sourceType {
        stCode
        stId
        stName
        stState
      }
    }
  }
`;
export const ALL_COLLECTION_COST = gql`
  query GetAllCollectionCost($limit: [Int], $order: [[String]], $state: [Int]) {
    getAllCollectionCost(limit: $limit, order: $order, state: $state) {
      ccId
      ccInitialRange
      ccEndRange
      ccRate
      ccState
      ccCapital
      ccInterest
      ccQualification
    }
  }
`;

export const ALL_SOURCE_TYPE = gql`
  query GetAllSourceType($limit: [Int], $order: [[String]], $state: [Int]) {
    getAllSourceType(limit: $limit, order: $order, state: $state) {
      stId
      stCode
      stName
      stState
    }
  }
`;

export const ALL_PAYMENTDEADLINE = gql`
  query GetAllPaymentDeadline($state: [Int], $order: [[String]]) {
    getAllPaymentDeadline(state: $state, order: $order) {
      pdId
      pdDays
      pdState
    }
  }
`;

export const ALL_TEACHING_SCALE = gql`
  query GetAllTeachingScales {
    getAllTeachingScales {
      tsId
      tsDecree
      tsScale
      tsSalary
      tsTeacherBonusPor
      tsTeacherBonus
      tsHardBonusPor
      tsHardBonus
      tsTotal
      tsContributionTeachingBenefitPor
      tsContributionTeachingBenefit
      tsTotalAccrued
      tsState
    }
  }
`;

export const ALL_REASON_REPLY = gql`
  query ReasonReply($state: Int, $order: [[String]]) {
    reasonReply(state: $state, order: $order) {
      idReasonReply
      name
      state
    }
  }
`;
export const ALL_HEARING_RESULT = gql`
  query HearingResult($limit: [Int], $order: [[String]]) {
    hearingResult(limit: $limit, order: $order) {
      idHearingResult
      name
      state
    }
  }
`;
